// const baseurl = "https://api-new.fusionkitchen.co.uk";
// const baseurl_website = "https://newlandingapi.fusiontesting.co.uk";
// const baseurl = "https://api-newdev.fusionkitchen.co.uk";
const baseurl = process.env.REACT_APP_KITCHEN_SERVER_URL;
const innovativeUrl = process.env.REACT_APP_INNOVATIVE_SERVER_URL;

// const baseurl = "https://api-newstaging.fusionkitchen.co.uk";

// const baseurl_new = "https://multiprinter.fusiontesting.co.uk";
export const HOMEPAGEURL = baseurl + "/BannerSection";
export const MEALDEAL = baseurl + "/MealDealSection";
export const ABOUTURL = baseurl + "/AboutUsSection";
export const GALLERYURL = baseurl + "/GallerySection";
export const REVIEWURL = baseurl + "/ReviewSection";
export const SIGNUPURL = baseurl + "/SignUpSection";
export const TABLEBOOKINGURL = baseurl + "/BookTableSection";
export const FOOTERURL = baseurl + "/homePage";
// export const FOOTERURL = "https://api-newdev.fusionkitchen.co.uk/clientHomePage";
export const FEEDBACKURL = baseurl + "/FeedbackSection";
export const PROMOTIONSTATUS = baseurl + "/getPromotionSection";
export const GETSITEMAP = baseurl + "/sitemapClient";
export const GETSEODATA = baseurl + "/getSeoDataClient";
export const SOCIALURL = baseurl + "/getSocialLink";
export const MENUIMAGEURL = baseurl + "/getMenuImage";

export const GETWALLETHISTORYURL = baseurl + "/getWalletHistory";
export const WALLETDASHBOARDURL = baseurl + "/walletDashboard";
export const GETSAVECARDURL = baseurl + "/getSaveCard";
export const ADDSAVECARDURL = baseurl + "/addSaveCard";
export const UPDATEPRIMARYSAVECARDURL = baseurl + "/updatePrimarySaveCard";
export const GETORDERHISTORY = baseurl + "/getOrderHistory";
export const GETBILLDETAIL = baseurl + "/getBillDetail";
export const GETADDRESSURL = baseurl + "/getAddress";
export const ADDADDRESSURL = baseurl + "/addAddress";
export const UPDATEADDRESSURL = baseurl + "/updateAddress";
export const DELETEADDRESSURL = baseurl + "/deleteAddress";
export const UPDATEPRIMARYADDRESSURL = baseurl + "/updatePrimaryAddress";
export const CREATEMYACCOUNTFEEDBACK = baseurl + "/createMyaccountFeedback";
export const ORDERAGAIN = baseurl + "/orderAgain";
export const ORDERTRACKING = baseurl + "/orderTracking";
export const SENDPROFILEOTP = baseurl + "/sendProfileOtp";
export const UPDATEPROFILE = baseurl + "/updateProfile";
export const LOGINOTPGENERATEURL = baseurl + "/loginOtpGenerate";
export const GETPROFILE = baseurl + "/getProfile";
export const APPLINK = baseurl + "/getAppDownloadLink";
//list
export const RESTAURANT = baseurl + "/getRestaurantDatas";
export const CUISINES = baseurl + "/getCuisinesList";
export const GETFILTER = baseurl + "/getRestaurantFiltersList";
//list end
export const NOTAKEAWAY = baseurl + "/noTakeaway";
export const DELETESAVECARDURL = baseurl + "/deleteSaveCard";
export const SSOLOGINREGISTER = baseurl + "/ssoLoginRegister";

// menu page apis
export const RESTAURANTDETAIL = baseurl + "/getRestaurantMenuDetail";
export const MENUDATA = baseurl + "/getMenuPage";
export const REVIEWDATA = baseurl + "/getReviewPage";
export const ABOUTDATA = baseurl + "/getAboutPage";
export const ORDERTIMING = baseurl + "/getOrderTime";
export const DELIVERYPOSTCODE = baseurl + "/checkDeliveryPostcode";
export const UPDATEFAVOURITE = baseurl + "/favouriteAction";
export const CHECKVOUCHERCODE = baseurl + "/checkVoucherCode";
export const GETTABLEGALLERY = baseurl + "/gettablegallery";
//addon api
export const ADDONDATA = baseurl + "/getItemAddonList";

// static api
export const LEADSIGNUP = baseurl + "/leadSignup";
export const CONTACTLESSDINNING = baseurl + "/contactlessDinningSignup";
export const CAREER = innovativeUrl + "/career";
export const BECOMEPARTNER = baseurl + "/partnerSignup";
export const RESELLER = baseurl + "/resellerSignup";

// feedback api
export const FEEDBACKSTATUS = baseurl + "/getClientFeedbackStatus";
export const CREATEEMAILFEEDBACK = baseurl + "/createEmailFeedback";

// checkout page api
export const UPDATECUSTOMERADDRESS = baseurl + "/updateCustomerAddressPopup";
export const PLACEORDERURL = baseurl + "/placeOrderWithPayment";
export const AFTERPLACEORDERURL = baseurl + "/validateOrder";
// export const PLACEORDERURL ="https://newlandingapi.fusiontesting.co.uk/placeOrderWithPayment";
export const CHARGESDETAILS = baseurl + "/getChargesDetail";
export const STRIPEPAYMENTDETAIL = baseurl + "/getStripePaymentDetail";

// get google api
export const GETGOOGLEPOSTCODE = baseurl + "/getGoogleAddress";

// get loyalty points
export const GETCHECKOUTLOYALTY = baseurl + "/getLoyaltyPoints";
//autocomplete postcode
export const AUTOCOMPLETEURL = baseurl + "/searchPostcode";
export const FeedBack = baseurl + "/commonFeedback";
export const ITEMAVILABLE = baseurl + "/itemAvailable";
// export const TABLEBOOKING = BASE_URL + "/getTableHistory";
export const TABLEBOOKING = baseurl + "/getTableHistory";
//subcibe Plan-R
export const SUBSCRIBEURL = baseurl + "/createSubscription";
export const SUBSCRIBEVOCHER = baseurl + "/getSubscriptionCoupon";

//OUR-BRANCH-R
export const BRANCHSTATUS = baseurl + "/getOurBranchSection";
//OUR-GALLRY-R
export const GALLERYSTATUS = baseurl + "/getGalleryGridSection";

//Franchise new API
export const CLIENTBRANCHLIST = baseurl + "/clientBranchList";
export const FRANCHISELEADFORM = baseurl + "/addFranchiseLeadForm";



